<app-auth-page-shell subtitle="Forgot your password?" [title]="submitted() ? 'Check your email' : 'Reset your password'">

  @if (!submitted()) {
    <p class="form-instructions mb-3 small">
      Enter the email address associated with your account and we'll send you a new password.
    </p>

    <form [formGroup]="forgotForm">
      <!-- Email Field -->
      <app-floating-input id="emailInput" label="Email Address" type="email" formControlName="emailId">
      </app-floating-input>

      <!-- Invisible reCAPTCHA -->
      <re-captcha #captchaRef size="invisible" (resolved)="onCaptchaResolved($event)"
        (error)="onCaptchaError()"></re-captcha>

      <!-- Submit Button -->
      <app-button
        type="submit"
        variant="filled"
        color="primary"
        [label]="isLoading() ? 'Sending...' : 'Send New Password'"
        [disabled]="isLoading()"
        style="display: block; margin-top: 1.25rem;"
        (click)="onSubmit()">
      </app-button>

      <div class="text-center mt-3 small fw-bold">
        <a routerLink="/auth/login" class="auth-link text-decoration-none fw-semibold">Back to Login</a>
      </div>
    </form>
  } @else {
    <div class="confirmation-state text-center">
      <i class="pi pi-envelope confirmation-icon" aria-hidden="true"></i>
      <p class="confirmation-text mb-4">
        If an account exists for that email address, a new password has been sent to it. Please check your inbox
        (and spam folder).
      </p>
      <app-button
        type="button"
        variant="filled"
        color="primary"
        label="Back to Login"
        (click)="onBackToLogin()">
      </app-button>
    </div>
  }

</app-auth-page-shell>
